import { RightOutlined } from "@ant-design/icons";
import { usersAPI } from "@api";
import { useDebounce } from "@hooks";
import { useQuery } from "@tanstack/react-query";
import { Button, Col, Input, List, Row, Space, Spin, Tag, Typography, notification } from "antd"
import i18next from "i18next";
import { useState } from "react";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";


const { Title, Text } = Typography;
const { Search } = Input;

export const UserMobile = () => {
  const language = i18next.language.substring(0, 2);
  const navigate = useNavigate()
  const { t } = useTranslation("common");
  const { t: tError } = useTranslation("error");
  const [searchUser, setSearchUser] = useState("");
  const debouncedSearchUser = useDebounce(searchUser, 300);

  const { isLoading, data: users } = useQuery({
    queryKey: ["users", { search: debouncedSearchUser }],
    queryFn: () =>
      usersAPI
        .getUsers({ search: debouncedSearchUser })
        .then(({ data }) => data.data),
    onError: ({ response }) =>
      notification.error({
        message: tError(response.data.message),
      }),
  });

  return (
    <Row>
      <Col span={24}>
        <Space direction="vertical" style={{ width: '100%' }}>
          <Search
            onChange={(e) => setSearchUser(e.target.value)}
            style={{
              width: "100%",
            }}
            allowClear
            placeholder={t("userTable.form.search")}
          />
          <Button type="primary" style={{ width: '100%' }} onClick={() => navigate('create')}>
            {t("meetDay.createUser")}
          </Button>
        </Space>
      </Col>
      <Col span={24}>
        <Spin spinning={isLoading} size="small">
          <List
            dataSource={users}
            renderItem={(user) => (
              <List.Item key={user.id} style={{ borderBottom: '1px solid black' }}>
                <List.Item.Meta
                  title={<Title level={5}> {user.fullName} </Title>}
                  description={
                    <Space>
                      <Text> {user.email} - {user.country?.name[language]} </Text>
                    </Space>
                  }
                />
                <Button icon={<RightOutlined />} onClick={() => navigate(`${user.id}/edit`)} />
              </List.Item>
            )}
          />
        </Spin>
      </Col>
    </Row>
  )
}